<!-- eslint-disable camelcase -->
<!-- eslint-disable camelcase -->
/* eslint-disable camelcase */
<!-- <template>
  <div>
    <Highmaps :options="defaultOptions" />
  </div>
</template>

<script>
import Highcharts from 'highcharts';
import loadMap from 'highcharts/modules/map';
import exportData from 'highcharts/modules/export-data';
import exporting from 'highcharts/modules/exporting';
import noData from 'highcharts/modules/no-data-to-display';
import loadDrilldown from 'highcharts/modules/drilldown';
import offlineExporting from 'highcharts/modules/offline-exporting';
import { genComponent } from 'vue-highcharts';

// default map
import NigerianMap from './ng-all.geo.json';

// default map options
import defaultOptions from './defaultOptions';

// map data
import regionsMap from './mapData/regions';

import {
  // eslint-disable-next-line camelcase
  AkwaIbom as Akwa_Ibom,
  Bayelsa,
  // eslint-disable-next-line camelcase
  CrossRiver as Cross_River,
  Rivers,
  Delta,
  Edo,
} from './mapData/south-south';

import {
  Abia, Ebonyi, Imo, Enugu, Anambra,
} from './mapData/south-east';

import {
  Ondo, Ogun, Osun, Lagos, Ekiti, Oyo,
} from './mapData/south-west';

import {
  Adamawa, Bauchi, Borno, Gombe, Taraba, Yobe,
} from './mapData/north-east';

import {
  Jigawa, Kano, Katsina, Kebbi, Sokoto, Kaduna, Zamfara,
} from './mapData/north-west';

import {
  Nasarawa, Niger, Plateau, Kwara, Kogi, Benue, Fct as FCT,
} from './mapData/north-central';

// load map
loadMap(Highcharts);
exporting(Highcharts);
offlineExporting(Highcharts);
exportData(Highcharts);
noData(Highcharts);
loadDrilldown(Highcharts);

export default {
  name: 'BaseMap',
  components: {
    Highmaps: genComponent('Highmaps', Highcharts),
  },
  props: {
    mapObject: {
      type: Object,
      default: () => ({}),
    },
    level: {
      type: Number,
      default: 0,
    },
    lgaState: {
      type: String,
    },
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      defaultOptions: { ...defaultOptions },
      lgaMapData: {
        Jigawa,
        Kano,
        Katsina,
        Kebbi,
        Sokoto,
        Kaduna,
        Zamfara,
        Nasarawa,
        Niger,
        Plateau,
        Kwara,
        Kogi,
        Benue,
        FCT,
        Abia,
        Ebonyi,
        Imo,
        Enugu,
        Anambra,
        Ondo,
        Ogun,
        Osun,
        Lagos,
        Ekiti,
        Oyo,
        Akwa_Ibom,
        Bayelsa,
        Cross_River,
        Rivers,
        Delta,
        Edo,
        Adamawa,
        Bauchi,
        Borno,
        Gombe,
        Taraba,
        Yobe,
      },
    };
  },
  methods: {

    plotMapLevel(level) {
      // check space is in string and add underscore
      let lgaState = '';
      if (this.lgaState) {
        lgaState = this.lgaState.replace(/\s/g, '_');
      }

      switch (level) {
        case 1:
          this.defaultOptions.plotOptions.map.mapData = NigerianMap;
          break;
        case 2:
          this.defaultOptions.plotOptions.map.mapData = regionsMap;
          break;
        case 3:
          this.defaultOptions.plotOptions.map.mapData = this.lgaMapData[lgaState].data;
          break;
        case 4:
          this.defaultOptions.plotOptions.map.mapData = NigerianMap;
          break;
        default:
          this.defaultOptions.plotOptions.map.mapData = NigerianMap;
          break;
      }
      this.defaultOptions = { ...this.defaultOptions };
    },
  },
  watch: {
    mapObject: {
      handler(newVal) {
        this.defaultOptions = Object.assign(this.defaultOptions, newVal);
      },
      immediate: true,
      deep: true,
    },
    level(newVal) {
      this.plotMapLevel(newVal);
    },
    lgaState() {
      this.plotMapLevel(this.level);
    },
  },
  created() {
    this.plotMapLevel(this.level);
  },

  mounted() {
    // changing the title of the text when downloaded
    this.defaultOptions.exporting.chartOptions.title.text = this.title;
  },
};
</script> -->

<!-- <template>
  <div id="container" style="width: 100%; height: 500px;"></div>
</template>

<script>
// Import necessary modules from Highcharts
import Highcharts from 'highcharts'; // Main Highcharts module
import loadMap from 'highcharts/modules/map'; // Module for loading maps
import exportData from 'highcharts/modules/export-data'; // Module for exporting data
import exporting from 'highcharts/modules/exporting'; // Module for exporting charts
import noData from 'highcharts/modules/no-data-to-display'; // Module for displaying "no data" message
// Load required Highcharts modules
loadMap(Highcharts);
exporting(Highcharts);
exportData(Highcharts);
noData(Highcharts);

export default {
  name: 'BaseMap',
  mounted() {
    // When the component is mounted, render the Ethiopian map
    this.renderEthiopianMap();
  },
  methods: {
    async renderEthiopianMap() {
      try {
        // Fetch GeoJSON data for Ethiopia
        const topology = await fetch(
          'https://code.highcharts.com/mapdata/countries/et/et-all.geo.json',
        ).then((response) => response.json());

        console.log('Topology data:', topology); // Log the fetched GeoJSON data

        // Define dummy data
        const data = [
          { 'hc-key': 'et-be', value: 10, name: 'Be' },
          { 'hc-key': 'et-2837', value: 11, name: '2837' },
          { 'hc-key': 'et-ha', value: 12, name: 'Ha' },
          { 'hc-key': 'et-sn', value: 13, name: 'Sn' },
          { 'hc-key': 'et-ga', value: 14, name: 'Ga' },
          { 'hc-key': 'et-aa', value: 15, name: 'Aa' },
          { 'hc-key': 'et-so', value: 16, name: 'So' },
          { 'hc-key': 'et-dd', value: 17, name: 'Dd' },
          { 'hc-key': 'et-ti', value: 18, name: 'Ti' },
          { 'hc-key': 'et-af', value: 19, name: 'Af' },
          { 'hc-key': 'et-am', value: 20, name: 'Am' },
        ];

        // Render the map using Highcharts
        Highcharts.mapChart('container', {
          chart: {
            map: topology,
          },
          title: {
            text: 'Ethiopian Map', // Set map title
          },
          subtitle: {
            text: 'Source map: <a href="https://code.highcharts.com/mapdata/countries/et/et-all.geo.json">Ethiopia</a>', // Set subtitle with link to source data
          },
          mapNavigation: {
            enabled: true, // Enable map navigation
            buttonOptions: {
              verticalAlign: 'bottom', // Align navigation buttons at the bottom
            },
          },
          colorAxis: {
            min: 0, // Minimum value of color axis
          },
          series: [{
            data: data, // Use dummy data
            name: 'Random data', // Series name
            states: {
              hover: {
                color: '#BADA55', // Color on hover
              },
            },
            dataLabels: {
              enabled: true, // Enable data labels
              format: '{point.name}', // Format of data labels
            },
          }],
        });
      } catch (error) {
        console.error('Error fetching or processing map data:', error);
      }
    },
  },
};
</script>

<style scoped>
/* Styling for the map container */
#container {
  width: 100%; /* Full width */
  height: 500px; /* Set height to 500px */
}
</style> -->

<template>
  <!-- Container for the map -->
  <div id="container" style="width: 100%; height: 500px;"></div>
</template>

<script>
// Import necessary modules from Highcharts
import Highcharts from 'highcharts'; // Main Highcharts module
import loadMap from 'highcharts/modules/map'; // Module for loading maps
import exportData from 'highcharts/modules/export-data'; // Module for exporting data
import exporting from 'highcharts/modules/exporting'; // Module for exporting charts
import noData from 'highcharts/modules/no-data-to-display'; // Module for displaying "no data" message

// Import GeoJSON data for Ethiopia
import ethiopiaGeoJSON from './eth-all.geo.json';

// Load required Highcharts modules
loadMap(Highcharts);
exporting(Highcharts);
exportData(Highcharts);
noData(Highcharts);

export default {
  name: 'BaseMap',
  mounted() {
    // When the component is mounted, render the Ethiopian map
    this.renderEthiopianMap();
  },
  methods: {
    renderEthiopianMap() {
      try {
        // Render the map using Highcharts
        Highcharts.mapChart('container', {
          chart: {
            map: ethiopiaGeoJSON,
          },
          title: {
            text: 'Ethiopian Map', // Set map title
          },
          mapNavigation: {
            enabled: true, // Enable map navigation
            buttonOptions: {
              verticalAlign: 'bottom', // Align navigation buttons at the bottom
            },
          },
          colorAxis: {
            min: 0, // Minimum value for the color axis
            max: 100, // Maximum value for the color axis
            type: 'linear', // Type of color axis
            stops: [
              [0, '#FFA07A'], // Custom color for state 1
              [0.2, '#00FFFF'], // Custom color for state 2
              [0.4, '#7FFF00'], // Custom color for state 3
              [0.6, '#9932CC'], // Custom color for state 4
              [0.8, '#FFD700'], // Custom color for state 5
              [1, '#FF6347'], // Custom color for state 6
            ],
          },
          series: [{
            name: 'Ethiopia Map', // Series name
            borderColor: '#A0A0A0', // Color of country borders
            nullColor: 'rgba(200, 200, 200, 0.3)', // Color for countries with no data
            showInLegend: false, // Hide legend entry for this series
            mapData: ethiopiaGeoJSON, // Use GeoJSON data
            data: [
              { 'hc-key': 'et-be', value: 50 },
              { 'hc-key': 'et-2837', value: 70 },
              { 'hc-key': 'et-ha', value: 30 },
              { 'hc-key': 'et-sn', value: 80 },
              { 'hc-key': 'et-ga', value: 60 },
              { 'hc-key': 'et-aa', value: 90 },
              { 'hc-key': 'et-so', value: 40 },
              { 'hc-key': 'et-dd', value: 55 },
              { 'hc-key': 'et-ti', value: 75 },
              { 'hc-key': 'et-af', value: 20 },
              { 'hc-key': 'et-am', value: 85 },
            ],
            dataLabels: {
              enabled: true, // Enable data labels
              format: '{point.properties.name}', // Format for data labels
            },
            states: {
              hover: {
                color: '#BADA55', // Color on hover
              },
            },
          }],
          credits: {
            enabled: false, // Disable credits
          },
        });
      } catch (error) {
        console.error('Error fetching or processing map data:', error);
      }
    },
  },
};
</script>

<style scoped>
/* Styling for the map container */
#container {
  width: 100%; /* Full width */
  height: 500px; /* Set height to 500px */
}
</style>
